function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}


class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[class^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

// cart
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);


class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class LangSwitcher extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.l-header');
    this.langSelect = this.querySelector('.lang-switch');
    this.wovnLangSwitcher = document.querySelector('.wovn-languages');
    this.langSelect.addEventListener('change', this.switch.bind(this));
    window.addEventListener('wovnApiReady', this.wovnApiReady.bind(this));
    window.addEventListener('wovnLangChanged', this.wovnLangChanged.bind(this));
  }

  wovnApiReady(event) {
    const selectLang = WOVN.io.getCurrentLang()
    this.querySelector('.lang-switch option[value="'+selectLang.code+'"]').selected = true;
  }

  wovnLangChanged(event) {
    this.lang = this.cart_lang = WOVN.io.getCurrentLang().code;
    switch (this.cart_lang) {
      case "zh-CHS":
      this.cart_lang = "zh-CN"
      break;
    }
    const selectLang =  this.langSelect.value
    
    if(this.lang != selectLang){
      this.querySelector('.lang-switch option[value="'+this.lang+'"]').selected = true;
    }
    this.header.classList.remove('scrolled');
    //window.dispatchEvent(new Event('wovnLangChanged'))
    //const directCheckout = document.getElementById('cart-notification-form')
    //if(directCheckout && this.lang != "ja")directCheckout.action = "/cart?locale="+this.lang;
  }

  switch(event) {
    event.preventDefault();
    const selectLang =  this.langSelect.value
    WOVN.io.changeLang(selectLang)
    window.dispatchEvent(new Event('wovnLangChanged'))
  }
}

customElements.define('lang-switch-ele', LangSwitcher);


//パスワードの表示・非表示切り替え
function enterFocusBtn(e) {
  if (e.code === 'Enter') {
      e.target.click();
  }
}

// Clean Theme Update JS UI Tweaks  
function closeAllOptions({targetElement}) {
  if (targetElement) {
    // Check if targetElement itself has .active or .open classes (but leave .js-option anchors)
    if (!targetElement.classList.contains('js-option') && (targetElement.classList.contains('active') || targetElement.classList.contains('open'))) {
      targetElement.classList.remove('active', 'open');
    }
    // Search down the DOM tree within the target element for elements with .active or .open classes
    // But leave .js-option anchor elements untouched
    const activeOpenElements = targetElement.querySelectorAll('.active, .open');
    activeOpenElements.forEach((element) => {
      // Skip .js-option anchor elements - leave them as is
      const isJsOptionAnchor = element.classList.contains('js-option') && element.tagName === 'A';
      if (!isJsOptionAnchor) {
        element.classList.remove('active', 'open');
      }
    });
  }
}

// Reusable function to setup outside click handlers
function setupOutsideClick({ target, excludeSelectors = [], closeOnSelectors = [], listenOnDocument = false, minWidth = 768 }) {
  if (window.innerWidth > minWidth) {
    const targetElements = document.querySelectorAll(target);
    console.log(targetElements);

    if (!targetElements || targetElements.length === 0) return;

    const listener = (event) => {
      // Check if click is on elements that should trigger closing (e.g., overlay)
      const isCloseTrigger = closeOnSelectors.some(selector => {
        return event.target.closest(selector);
      });

      // If clicking on a close trigger, close immediately
      if (isCloseTrigger) {
        targetElements.forEach(targetElement => {
          closeAllOptions({targetElement});
        });
        return;
      }

      // Check if click is inside any of the target elements
      const isInsideAnyTarget = Array.from(targetElements).some(element => 
        element.contains(event.target)
      );
    
      // Check if click is on excluded elements
      const isExcluded = excludeSelectors.some(selector => {
        return event.target.closest(selector);
      });

      // Determine if we should close based on listenOnDocument flag
      let shouldClose = false;
      if (listenOnDocument) {
        // When listening on document, close if click is outside all targetElements
        shouldClose = !isInsideAnyTarget && !isExcluded;
      } else {
        // When listening on targetElements, close if click is inside but not on excluded elements
        shouldClose = isInsideAnyTarget && !isExcluded;
      }

      if (shouldClose) {
        // Close options for all target elements
        targetElements.forEach(targetElement => {
          closeAllOptions({targetElement});
        });
      }
    };

    if (listenOnDocument) {
      document.addEventListener('click', listener);
      console.log('document listener added');
    } else {
      // Add listener to each target element
      targetElements.forEach(targetElement => {
        targetElement.addEventListener('click', listener);
      });
    }
  }
}

// Setup for selector wrap (closes when clicking outside or on overlay)
setupOutsideClick({
  target: ".js-selectorwrap",
  listenOnDocument: true,
  closeOnSelectors: ['.c-selector__overlay']
});

setupOutsideClick({
  target: ".l-header__selector",
  listenOnDocument: true,
  closeOnSelectors: ['.c-selector__overlay']
});

// Setup for search form (closes when clicking inside but outside specific elements)
setupOutsideClick({
  target: ".ec-search",
  excludeSelectors: ['.ec-search__optionswrap', '.ec-search__options', '.js-searchoptions']
});

// Apply active classes and update labels based on localStorage values
function applyStoredFilters() {
  const ecSearch = document.querySelector('.ec-search');
  if (!ecSearch) return;

  // Map of input names to their container selectors
  const filterMap = {
    'filter.p.vendor': '.js-brand-option',
    'filter.p.product_type': '.js-item-option',
    'filter.p.tag': '.js-color-option'
  };

  Object.keys(filterMap).forEach(inputName => {
    const storedValue = localStorage.getItem(inputName);
    if (!storedValue) return;

    // Set the hidden input value
    const hiddenInput = document.querySelector(`input[name="${inputName}"].js-input`);
    if (hiddenInput) {
      hiddenInput.value = storedValue;
    }

    // Find the container
    const containerSelector = filterMap[inputName];
    const container = ecSearch.querySelector(containerSelector);
    if (!container) return;

    // Split comma-separated values
    const valuesArray = storedValue.split(',').map(v => v.trim()).filter(v => v);
    if (valuesArray.length === 0) return;

    // Find all .js-option elements in the container
    const options = container.querySelectorAll('a.js-option');
    
    // Remove active from all options first
    options.forEach(option => {
      option.classList.remove('active');
    });

    // Collect active labels
    const activeLabels = [];

    // Add active class to matching options
    options.forEach(option => {
      const optionValue = (option.dataset.value || '').trim();
      
      if (valuesArray.includes(optionValue)) {
        option.classList.add('active');
        const optionLabel = option.dataset.label || '';
        if (optionLabel) {
          activeLabels.push(optionLabel);
        }
      }
    });

    // Update the label
    const labelElement = container.querySelector('.js-label');
    if (labelElement && activeLabels.length > 0) {
      const htmlLabels = activeLabels.map(label => {
        if (label && label.includes('<span')) {
          return label;
        } else {
          return `<span class="label">${label}</span>`;
        }
      }).join(',');
      labelElement.innerHTML = htmlLabels;
    }
  });
}

// Store hidden input values in localStorage when they change
function setupHiddenInputListeners() {
  const hiddenInputs = document.querySelectorAll('input[type="hidden"].js-input');
  hiddenInputs.forEach(input => {
    // Use input event to detect value changes
    input.addEventListener('input', (event) => {
      if (event.target.value) {
        localStorage.setItem(event.target.name, event.target.value);
        console.log('Stored:', event.target.name, '=', event.target.value);
        // Re-apply filters after storing
        applyStoredFilters();
      }
    });
  });
}

// On form submit, store all hidden input values in localStorage
function setupFormSubmitListener() {
  const searchForm = document.querySelector('form[name="search"]');
  if (searchForm) {
    searchForm.addEventListener('submit', (event) => {
      const hiddenInputs = document.querySelectorAll('input[type="hidden"].js-input');
      hiddenInputs.forEach(input => {
        if (input.value) {
          localStorage.setItem(input.name, input.value);
          console.log('Form submit - stored:', input.name, '=', input.value);
        }
      });
    });
  }
}

// Get all remaining active facet texts from the page (excluding the one being removed)
function getRemainingActiveFacets(excludeFacetRemove) {
  const allFacetRemoves = document.querySelectorAll('facet-remove');
  const remainingFacets = [];
  
  allFacetRemoves.forEach(facetRemove => {
    // Skip the facet being removed
    if (facetRemove === excludeFacetRemove) return;
    
    const buttonInner = facetRemove.querySelector('.active-facets__button-inner');
    if (buttonInner) {
      const text = buttonInner.textContent.trim().replace(/\s+/g, '');
      if (text) {
        remainingFacets.push(text.toLowerCase());
      }
    }
  });
  
  return remainingFacets;
}

// Handle facet-remove clicks to update localStorage
function setupFacetRemoveListener() {
  // Use event delegation to handle dynamically added facet-remove elements
  document.addEventListener('click', (event) => {
    const facetRemove = event.target.closest('facet-remove');
    if (!facetRemove) return;

    const buttonInner = facetRemove.querySelector('.active-facets__button-inner');
    if (!buttonInner) return;

    // Get the text content and remove whitespace
    const textToRemove = buttonInner.textContent.trim().replace(/\s+/g, '');
    console.log('=== Facet remove clicked ===');
    console.log('Text to remove:', textToRemove);

    // First, remove the clicked facet from localStorage
    const filterKeys = ['filter.p.vendor', 'filter.p.product_type', 'filter.p.tag'];

    filterKeys.forEach(key => {
      const storedValue = localStorage.getItem(key);
      if (!storedValue) return;

      // Split by comma and trim each value
      const valuesArray = storedValue.split(',').map(v => v.trim()).filter(v => v);
      
      // Remove the matching value (case-insensitive comparison)
      const filteredValues = valuesArray.filter(value => {
        // Compare after removing whitespace from both
        const valueNoSpace = value.replace(/\s+/g, '');
        return valueNoSpace.toLowerCase() !== textToRemove.toLowerCase();
      });

      if (filteredValues.length < valuesArray.length) {
        // Value was found and removed
        if (filteredValues.length > 0) {
          // Update with remaining values
          localStorage.setItem(key, filteredValues.join(','));
          console.log(`Updated localStorage: ${key} = "${filteredValues.join(',')}"`);
        } else {
          // Remove key if no values left
          localStorage.removeItem(key);
          console.log(`Removed from localStorage: ${key}`);
        }
      }
    });

    // Get remaining active facets (excluding the one being removed)
    const remainingFacets = getRemainingActiveFacets(facetRemove);
    console.log('Remaining active facets:', remainingFacets);

    // Now check localStorage and remove any items that don't match remaining facets
    filterKeys.forEach(key => {
      const storedValue = localStorage.getItem(key);
      if (!storedValue) return;

      // Split by comma and trim each value
      const valuesArray = storedValue.split(',').map(v => v.trim()).filter(v => v);
      
      // Keep only values that match remaining facets
      const syncedValues = valuesArray.filter(value => {
        const valueNoSpace = value.replace(/\s+/g, '');
        return remainingFacets.includes(valueNoSpace.toLowerCase());
      });

      if (syncedValues.length < valuesArray.length) {
        // Some values were removed
        if (syncedValues.length > 0) {
          localStorage.setItem(key, syncedValues.join(','));
          console.log(`Synced localStorage: ${key} = "${syncedValues.join(',')}"`);
        } else {
          localStorage.removeItem(key);
          console.log(`Removed from localStorage (no matches): ${key}`);
        }
      }
    });

    // Re-apply filters after syncing localStorage
    setTimeout(() => {
      applyStoredFilters();
    }, 100);
  });
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    applyStoredFilters();
    setupHiddenInputListeners();
    setupFormSubmitListener();
    setupFacetRemoveListener();
  });
} else {
  applyStoredFilters();
  setupHiddenInputListeners();
  setupFormSubmitListener();
  setupFacetRemoveListener();
}
